<template>
    <div>
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtros" :sync="true" @sync="load()" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fas fa-warehouse fa-fw"
                            placeholder="Selecione o Local..."
                            type="select"
                            service="estoque_locals.index"
                            optionsData="id_estoque_local"
                            optionsMode="aql"
                            optionsName="estoque_locals.index.sup"
                            :optionsParm="{ sup: 1 }"
                            v-model="filtros.id_estoque_local" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fas fa-filter fa-fw"
                            placeholder="Todos os tipos..."
                            type="select"
                            service="estoque_tipo_movimentacaos.index"
                            optionsData="id_estoque_tipo_movimentacao"
                            optionsMode="aql"
                            :optionsParm="{ ativos: true }"
                            v-model="filtros.id_estoque_tipo_movimentacao" />
                    </div>
                    
                </div>
                <div class="form-row mt-2">
                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="fa-solid fa-signs-post fa-fw"
                            type="select"
                            placeholder="Todas..."
                            :optionsList="[
                                { id: 'E', search: 'Entradas' },
                                { id: 'S', search: 'Saídas' },
                            ]" 
                            optionsData="id" 
                            v-model="filtros.direcao" />
                    </div>
                    <div class="col col-12 col-md-4">
                        <az-input 
                            icon="fa fa-search fa-fw" 
                            v-model="filtros.search">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary" :disabled="!filtros.id_estoque_local" type="button" @click="transformar()"
                                        data-toggle="tooltip" data-placement="top" title="Montagem / Fabricação">
                                        <i class="fa-solid fa-box"></i>
                                    </button>
                                    <print-export printid="lista-impressao" :dados="dados_exportacao" pagina="suprimentos-movimentacoes" :parms="parms_relatorios" />
                                </div>
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fab fa-google fa-fw"
                            placeholder="Todos os Grupos..."
                            type="select"
                            service="estoque_grupos.index"
                            optionsData="id_estoque_grupo"
                            optionsMode="aql"
                            v-model="filtros.id_estoque_grupo" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            placeholder="Todos o itens..."
                            icon="fa-solid fa-box fa-fw"
                            type="autocomplete" 
                            optionsMode="aql"
                            service="estoque_items.index"
                            :optionsSync="false"
                            optionsData="id_estoque_item"
                            v-model="filtros.id_estoque_item" />
                    </div>
                </div>

                <!-- Consumos -->
                <div class="form-row mt-2">
                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="fa-regular fa-calendar fa-fw"
                            type="select"
                            placeholder="Data Movimentação"
                            :optionsList="[
                                { id: 'R', search: 'Data Registro' },
                            ]" 
                            optionsData="id" 
                            v-model="filtros.tipo_data" />
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="far fa-building fa-fw"
                            type="select"
                            placeholder="Unidade..."
                            :optionsList="$util.unidades_com_tags(false, true)"
                            optionsData="id_unidade_operacao"
                            v-model="filtros.id_unidade_operacao" />
                    </div>

                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="fas fa-funnel-dollar fa-fw"
                            type="select"
                            placeholder="Centro de Custo..."
                            :optionsList="lista_centro_custo"
                            optionsData="id_centro_custo"
                            v-model="filtros.id_centro_custo" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input 
                            placeholder="Paciente..."
                            icon="fas fa-user"
                            type="autocomplete" 
                            optionsMode="aql"
                            service="pacientes.index"
                            optionsDisplay="search"
                            ref="info_paciente"
                            v-model="filtros.paciente" 
                            :optimized_ac="true">
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            placeholder="Fornecedor..."
                            icon="fas fa-industry fa-fw"
                            type="autocomplete"
                            optionsMode="aql"
                            service="fornecedores.index"
                            optionsData="id_fornecedor"
                            optionsDisplay="search"
                            v-model="filtros.id_fornecedor" />
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-3">
            <div class="indeterminate" v-if="$store.state.loading && dados"></div>
            <div class="determinate" v-else></div>
        </div>        

        <az-empty-state v-if="!lista || !lista.length" icon="fas fa-exchange-alt" msg="Nenhuma movimentação identificada." />

        <div v-else id="lista-impressao">

            <cabecalho-generico titulo="Movimentações">
                <div v-if="filtros_busca">
                    <div>{{ $util.filtro_2_periodo(filtros_busca) }}</div>
                    <div v-if="nome_local">Local: {{ nome_local }}</div>
                    <div v-if="filtros.search">Pesquisa: {{ filtros.search }}</div>
                </div>
            </cabecalho-generico>

            <div class="card carde mb-2 w3-animate-opacity" v-for="(mov, inx) in lista" :key="inx">
                <div class="card-body py-1">
                    <div class="row" >
                        <div class="col col-12 col-md-2">
                            <small>
                                {{ mov.local.search }}
                            </small>
                            <div>
                                #{{ mov.id_estoque_movimentacao }}
                                <span v-if="mov.st_doc">
                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                    {{ mov.st_doc }}
                                </span>
                                <a href="#" @click.prevent="abrir_anexar_arquivo(mov)" class="ml-2 card-link">
                                    <i class="fa fa-plus" aria-hidden="true" v-if="!mov.arquivos.length"></i>
                                    <div class="spinner-border spinner-border-sm" role="status" v-else-if="mov.carregando">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <i class="fa fa-paperclip" aria-hidden="true" v-else></i>
                                </a>
                            </div>
                        </div>
                        <div class="col col-12 col-md-2">
                            <small v-if="mov.tipo">
                                {{ ( mov.tipo.id_estoque_tipo_movimentacao == 2 && mov.in_fator_saldo > 0 ) ? 'Devolução' : mov.tipo.search }}
                                <span v-if="mov.id_marcacao">
                                    Paciente
                                </span>
                            </small>
                            <div title="Data da Movimentação">
                                <small>
                                    <i class="fa-regular fa-calendar fa-fw mr-1"></i>
                                    {{ $util.getFormatDate(mov.dt_movimentacao) }}
                                    {{ mov.dt_movimentacao.substr(11,5) }}
                                </small>
                            </div>
                            <div title="Data de Registro da Movimentação">
                                <small>
                                    <i class="fa-solid fa-registered fa-fw mr-1"></i>
                                    {{ $util.getFormatDate(mov.dt_criacao) }}
                                    {{ mov.dt_criacao.substr(11,5) }}
                                </small>
                            </div>
                        </div>
                        <div class="col col-12 col-md-4">
                            <div class="small">
                                {{ mov.item.search }} 
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                #{{ mov.id_estoque_item }}
                            </div>
                            <div class="small text-muted" v-if="mov.link && mov.link.model && mov.link.model.st_observacao">
                                {{ mov.link.model.st_observacao }}
                            </div>
                            <div class="small text-muted" v-if="mov.complemento">
                                {{ mov.complemento }}
                            </div>
                            <div class="small text-muted text-nowrap text-truncate" v-if="mov.st_observacao">
                                {{ mov.st_observacao }}
                            </div>
                        </div>
                        <div class="col col-12 col-md-4 d-flex justify-content-between">
                            <div>
                                <div>
                                    <i class="fa fa-plus-circle text-success mr-1" aria-hidden="true" v-if="mov.in_fator_saldo > 0"></i>
                                    <i class="fa fa-minus-circle text-danger mr-1" aria-hidden="true" v-else-if="mov.in_fator_saldo < 0"></i>
                                    {{ mov.in_quantidade }} 
                                    <small class="text-muted">{{ mov.item.st_unidade_estoque }}</small>

                                    <span v-if="mov.st_lote && mov.st_lote != 'Sem Lote'">
                                        <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                                        Lote: {{ mov.st_lote }}

                                        <span v-if="mov.lote && mov.lote.dt_validade" class="ml-1 small text-muted" title="Data de Validade do Lote">
                                            (Val: {{ $util.getFormatDate(mov.lote.dt_validade) }})
                                        </span>
                                    </span>
                                </div>
                                <div>
                                    {{ $util.formatMoeda(mov.in_quantidade * mov.dc_valor) }}
                                </div>
                                <div v-if="mov.centro && mov.centro.unidade_operacao">
                                    <span class="badge badge-light mr-2">
                                        {{ mov.centro.unidade_operacao.st_sigla }}
                                    </span>
                                    <span class="small text-muted">
                                        {{ mov.centro.search }}
                                    </span>
                                </div>
                            </div>
                            
                            <!-- Menu de opções -->
                            <div class="dropleft d-flex align-items-center justify-content-center order-1 order-md-2" v-if="mov.id_estoque_tipo_movimentacao == 11">
                                <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i class="fas fa-ellipsis-v"></i>
                                </a>
                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <button class="dropdown-item" @click="ver_composicao(mov)">
                                        Composição
                                    </button>
                                    <button class="dropdown-item" @click="imprimir_etiqueta(mov)">
                                        Etiqueta
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 

            <div v-if="pode_totalizar">
                <div class="alert alert-info d-flex justify-content-between mt-3">
                    <div>Total Qtde</div>
                    <div>{{ qtd_total }}</div>
                </div>
            </div>

            <!-- Paginação -->
            <nav class="navbar fixed-bottom navbar-light bg-light pb-3" v-if="dados && dados.last_page > 1">
                <div class="d-flex">
                    <paginate
                        class="mb-0"
                        :page-count="dados.last_page"
                        :container-class="'pagination'"
                        :page-class="'page-item'"
                        :page-link-class="'page-link'"
                        :prev-class="'page-link'"
                        :next-class="'page-link'"
                        :prev-text="'<<'"
                        :next-text="'>>'"
                        :click-handler="paginar">
                    </paginate>
                </div>
            </nav>
        </div>

        <transformacao ref="transform" @refresh="load" />
        <estoque-etiqueta ref="estoque_etiqueta" sufixo="mov" />
        <composicao-transformacao ref="comp" @refresh="load" />

        <template v-if="acao_anexar">
            <az-file-upload
                ref="upload"
                @refresh="carregar_arquivos()"
                :arquivos="item_arq.arquivos"
                :parms="{ 
                    model_type: 'estoqueMovimentacao', 
                    model_id: item_arq.id_estoque_movimentacao,
                }" />
        </template>

    </div>
</template>

<script>
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import PrintExport from '../../shared/PrintExport.vue';
import Transformacao from './Transformacao.vue';
import EstoqueEtiqueta from './EstoqueEtiqueta.vue';
import ComposicaoTransformacao from './ComposicaoTransformacao.vue';
import AzFileUpload from '../../util/AzFileUpload.vue';

export default {
    data() { 
        return { 
            search: "",
            viewMode: "S", 
            dados: [],
            firstload: false,
            montando: true, 
            filtros: { 
                inicio: this.$util.hoje(),
                fim: this.$util.hoje(),           
                id_estoque_local: this.$util.getCookie('estoque-armazem'),
                periodo: "s",
                id_estoque_tipo_movimentacao: "", 
                id_estoque_item: "", 
                id_estoque_grupo: "", 
                id_fornecedor: "", 
                direcao: "", 
                paciente: "", 
                tipo_data: "", 
                id_unidade_operacao: "", 
                id_centro_custo: "", 
            },
            filtros_busca: null, 
            page: 1, 
            pode_totalizar: false, 
            acao_anexar: false, 
            item_arq: null, 
        }
    },

    props: ['parms'], 

    components: { 
        AzInput,
        AzEmptyState,
        AzPeriodo, 
        CabecalhoGenerico, 
        PrintExport, 
        Transformacao, 
        EstoqueEtiqueta, 
        ComposicaoTransformacao, 
        AzFileUpload, 
    },

    computed: { 
        lista_centro_custo: function () { 
            if ( !this.filtros.id_unidade_operacao )
                return [];

            let unidade = this.$store.state.unidade.unidade_operacaos
                .find(item => item.id_unidade_operacao == this.filtros.id_unidade_operacao);

            if ( unidade )
                return unidade.centro_custos;

            return [];
        },

        parms_relatorios: function () { 
            if ( !this.lista ) { 
                return {};
            }

            return { 
                movimentacao_id: this.lista.map(item => item.id_estoque_movimentacao),
            };
        },

        qtd_total: function () { 
            if ( !this.dados )
                return 0;

            return this.dados.data.reduce((acc, item) => acc + ( item.in_quantidade * item.in_fator_saldo ), 0);
        },

        lista: function () { 
            if ( !this.dados )
                return;

            if ( this.filtros.search ) { 
                let reg = this.$util.getregex(this.filtros.search);
                return this.dados.data.filter(item => reg.test(JSON.stringify(item)));
            }

            return this.dados.data;
        },

        nome_local: function () {
            if ( !this.filtros_busca || !this.filtros_busca.id_estoque_local || !this.$store.state.options['estoque_locals.index'] )
                return;

            const local = this.$store.state.options['estoque_locals.index'].find(item => item.id_estoque_local == this.filtros_busca.id_estoque_local)

            return local ? local.search : '';
        },

        dados_exportacao: function () { 

            if ( !this.lista )
                return [];

            return this.lista.map(item => { 
                return { 
                    id: item.id_estoque_movimentacao, 
                    doc: item.st_doc, 
                    local: item.local.search,
                    tipo: ( ( item.tipo.id_estoque_tipo_movimentacao == 2 && item.in_fator_saldo > 0 ) ? 'Devolução' : item.tipo.search ),
                    data: this.$util.getFormatDate(item.dt_movimentacao), 
                    hora: item.dt_movimentacao.substr(11,5), 
                    id_item: item.id_estoque_item, 
                    item: item.item.search,
                    obs: ( ( item.link && item.link.model && item.link.model.st_observacao ) ? item.link.model.st_observacao + " \n" : '' ) 
                        + ( item.complemento ? item.complemento + " \n" : '' ) 
                        + ( item.st_observacao ? item.st_observacao : '' ),
                    qtde: item.in_quantidade,
                    lote: item.st_lote, 
                    valor: this.$util.formatMoeda(item.in_quantidade * item.dc_valor),
                }
            });

        }
    },

    methods: { 
        ver_composicao (mov) { 
            this.$refs.comp.abrir(mov);
        },

        imprimir_etiqueta(mov) {
            let item = { 
                checked: true,
                id_estoque_item: mov.id_estoque_item,
                lote: mov.st_lote,
                validade: mov.dt_validade,
                qtde: 1,
                search: mov.item.search,
            };

            this.$refs.estoque_etiqueta.show([item]);
        },

        transformar () { 
            this.$refs.transform.abrir(this.filtros.id_estoque_local);
        },

        paginar(page) { 
            this.load(page);
        },

        load(page) { 
            if ( this.montando )
                return;

            this.page = page ? page : 1;
            this.pode_totalizar = false;

            this.filtros_busca = _.cloneDeep(this.filtros);
            
            this.$util.load(this, { 
                service: 'estoque_movimentacoes',
                parms: { 
                    ...this.filtros, 
                    size: 200,
                    page: this.page,
                    movs: true, 
                },
                size: 200,
                loadTo: res => { 
                    this.dados = res;

                    if ( res.last_page == 1 ) { 
                        if ( _.uniq(this.dados.data.map(item => item.id_estoque_item)).length == 1 ) { 
                            this.pode_totalizar = true;
                        }
                    }
                }
            });
        },

        // Anexos 

        abrir_anexar_arquivo(item) { 
            this.item_arq = item;
            this.acao_anexar = true;

            // Ajuste para carregar os arquivos sempre que clicar no botão
            this.carregar_arquivos(true);
            return;
        
        },

        carregar_arquivos (abrir = false) {

            this.$store.commit('loading', true);

            this.$util.loadItem(this, {
                service: 'arquivos',
                func: 'links',
                parms: {
                    id: this.item_arq.id_estoque_movimentacao,
                    type: 'estoqueMovimentacao',
                }
            })
            .then(res => {
                this.item_arq.arquivos = res;

                if ( abrir ) {
                    this.$nextTick(() => {
                    this.$refs.upload.abrir();
                    });
                }
            })
            .finally(() => {
                this.$store.commit('loading', false);
            });

        },
    },

    beforeMount() { 
        let parms = this.$route.params;

        if ( parms.filtros ) { 
            Object.assign(this.filtros, parms.filtros);
            //this.filtros = parms.filtros;
        }
    },

    mounted() { 
        this.$store.commit("setBreadcrumb", [
            { name: "Suprimentos", path: "/suprimentos" },
            { name: "Movimentações", path: "/suprimentos/movimentacao" }
        ]);

        this.$nextTick(() => { 
            this.montando = false;
            this.load();
        });
    }
}
</script>